import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { StockStatus } from 'src/components/stock-status';
import { StockStatusStates } from 'src/components/stock-status/types';
import { ParamsAndReturnTypes } from 'src/components/translate';
import { StockStatusWrapper } from './styles';

interface IStockBadge {
  status?: StockStatusStates | null;
  statusText?: string | null;
  featuredOffer?: boolean;
}

export const StockBadge: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IStockBadge>
>> = props => {
  const { t } = useAppContext();

  const { status, statusText, featuredOffer } = props;

  const processedStatusText = statusText
    ? statusText.replace(/-/g, '\u2011') /* no-breaking hyphen in dates */
    : t(
        'product',
        `stock-status.${status ||
          'unknown'}` as keyof ParamsAndReturnTypes['product']
      );

  return (
    <StockStatusWrapper>
      <StockStatus
        status={status}
        tooltip={processedStatusText as string}
        tooltipPlacement="top"
        featuredOffer={featuredOffer}
      />
    </StockStatusWrapper>
  );
};
